/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Pagination from "@mui/material/Pagination";
import { ChangeEvent, useCallback, useEffect, useState } from "react";

interface TablePaginationProps {
	items: any[];
	pageSize: number;
	pageChange: (items: any[]) => void;
}
export const TablePagination = React.memo(
	({ items, pageSize, pageChange }: TablePaginationProps) => {
		const [pages, setPages] = useState(0);
		const [currentPage, setCurrentPage] = useState(0);
		const [showPagination, setShowPagination] = useState<boolean>(false);

		useEffect(() => {
			if (!items || items.length === 0) {
				setPages(0);
				setCurrentPage(0);
				pageChange([]);
				return;
			}

			setPages(Math.ceil(items.length / pageSize));
			handlePageChange(null, currentPage <= 1 ? 1 : currentPage);
			return;
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [currentPage, items, pageSize]);

		const handlePageChange = useCallback(
			(_event: ChangeEvent<unknown> | null, page: number) => {
				setCurrentPage(page);
				let startPos = (page - 1) * pageSize;
				startPos = startPos >= items.length ? 0 : startPos;
				const endPos =
					startPos + pageSize > items.length
						? items.length
						: startPos + pageSize;
				const pagedItems = items.slice(startPos, endPos);
				pageChange(pagedItems);
				setShowPagination(items.length > pageSize);
			},
			[items, pageChange, pageSize],
		);

		return (
			<>
				{showPagination && (
					<div className="flex justify-center py-4">
						<div className="col">
							<Pagination
								count={pages}
								page={currentPage}
								variant="outlined"
								shape="rounded"
								onChange={handlePageChange}
							/>
						</div>
					</div>
				)}
			</>
		);
	},
);
